module.exports = __webpack_public_path__ + "img/symbols.34cd12eb.svg";